var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{attrs:{"id":"pagebutton"}},[_vm._v(_vm._s(_vm.deviceId))]),_c('pagebutton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }